// extracted by mini-css-extract-plugin
export var activityContainer = "_l3-0";
export var typingIndicatorContainer = "_l3-1";
export var typingIndicatorDot = "_l3-2";
export var wave = "_l3-3";